import React from 'react';
import PropTypes from 'prop-types';
import Categories from './Categories';
import Options from './Options';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';


const Sidebar = (props) => (
    <div id="sidebar">
        <Accordion defaultActiveKey="0">
            <Card id="categories">
                <Accordion.Toggle as={Card.Header} eventKey="0">
                    <h3>Collections</h3>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                    <Card.Body>
                        <Categories
                            categories={props.categories}
                            onClick={props.onClick}
                            currentCategory={props.currentCategory}
                        />

                    </Card.Body>
                </Accordion.Collapse>
            </Card>
            <Card id="options">
                <Accordion.Toggle as={Card.Header} eventKey="1">
                    <h3>Options</h3>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="1">
                    <Card.Body>
                        <Options
                            onChange={props.onChange}
                            options={props.options}
                        />
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    </div>
);

Sidebar.propTypes = {
    categories: PropTypes.array,
    options: PropTypes.object,
    currentCategory: PropTypes.object,
    onClick: PropTypes.func,
    onChange: PropTypes.func
};

export default Sidebar;
